module.exports = __webpack_public_path__ + "static/media/s_v10_23.5a097f80.mp3";